import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import palette from '../../utils/colorPalette';
import { translateText } from '../../utils/translateText';
import i18n from '../../utils/i18n';
import { useTranslation } from 'react-i18next';

const TextField = ({
  placeholder,
  type,
  onChange,
  width,
  size,
  defaultValue,
  readOnly,
  ref,
  style,
  onFocus,
  onKeyPress,
}) => {
  const { t } = useTranslation();
  const language = i18n.language;
  const [isFocused, setIsFocused] = useState(false);
  const [value, setValue] = useState(!!defaultValue ? defaultValue : '');

  const handleFocus = () => {
    setIsFocused(true);
    onFocus && onFocus();
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    !!onChange && onChange(e.target.value);
  };

  useEffect(() => {
    if (!defaultValue) setValue('');
    else setValue(defaultValue);
  }, [defaultValue]);

  return (
    <StyledTextField $width={width}>
      <Label $hasvalue={!!value} $isfocused={isFocused}>
        {translateText({
          text: placeholder,
          globalLanguage: language,
        })}
      </Label>
      <Input
        type={!!type ? type : 'text'}
        onFocus={handleFocus}
        onKeyPress={onKeyPress}
        onBlur={handleBlur}
        onChange={handleChange}
        value={value}
        readOnly={readOnly}
        style={!!style ? style : null}
      />
    </StyledTextField>
  );
};

export default TextField;

const StyledTextField = styled.div`
  position: relative;
  width: ${(props) => (!!props.$width ? props.$width : '100%')};
  margin: 8px 0;
`;

const Label = styled.label`
  position: absolute;
  background: white;
  left: 8px;
  top: ${(props) => (props.$hasvalue || props.$isfocused ? '-7px' : '8px')};
  font-size: ${(props) =>
    props.$hasvalue || props.$isfocused ? '0.65rem' : '0.75rem'};
  color: ${(props) =>
    props.$hasvalue || props.$isfocused
      ? palette.textfield.default
      : palette.textfieldText.default};
  transition: top 0.2s, font-size 0.2s, color 0.2s;
  pointer-events: none; /* 입력 필드를 가려주기 위해 추가 */
`;

const Input = styled.input`
  width: calc(100% - 14px);
  padding: 4px 5px;
  border: 1px solid #ccc;
  border-color: ${(props) => props.borderColor};
  border-radius: 4px;
  font-size: 0.8rem;
  font-family: NotoSansKR-Light;
  transition: border-color 0.2s;
  color: ${palette.text.default};
  background-color: ${(props) => props.backgroundColor || 'white'};
  &:focus {
    outline: none;
    border-color: ${palette.textfield.default};
  }
`;
